import React from 'react';
import PropTypes from 'prop-types';

import BasicButton from 'components/BasicButton';

import './styles.css';

const DealPerceptionForm = props => {
  const { onClickGoodDeal, onClickBadDeal } = props;

  return (
    <div className="deal-perception-form">
      <div className="deal-perception-form__text">
        What is your perception of this deal?
      </div>

      <div className="deal-perception-form__buttons">
        <div className="deal-perception-form__button">
          <BasicButton
            btnWidth={85}
            btnHeight={35}
            btnFontSize="0.8571rem"
            btnFontWeight={600}
            btnText="Good Deal"
            btnArrow={false}
            controlFunc={onClickGoodDeal}
          />
        </div>

        <div className="deal-perception-form__button">
          <BasicButton
            btnWidth={85}
            btnHeight={35}
            btnFontSize="0.8571rem"
            btnFontWeight={600}
            btnText="Bad Deal"
            btnArrow={false}
            controlFunc={onClickBadDeal}
            btnBg="#fff"
            btnHoverBg="#f40"
          />
        </div>
      </div>
    </div>
  );
};

DealPerceptionForm.propTypes = {
  onClickGoodDeal: PropTypes.func.isRequired,
  onClickBadDeal: PropTypes.func.isRequired,
};

export default DealPerceptionForm;
